module.exports = require("@foundit/common-functions");